export default [{
  path: '/taxation-project-manage',
  name: 'taxation-project-manage',
  component: resolve => require(['views/taxation-project-manage'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/taxation-project-manage/taxation-project-form/:id/:isEdit',
  props: true,
  name: 'taxation-project-form',
  component: resolve => require(['views/taxation-project-form'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/scan-payment-counselor',
  name: 'scan-payment-counselor',
  component: resolve => require(['views/scan-payment-counselor'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/export-history/scan-payment-counselor',
  name: 'export-history-scan-payment-counselor',
  component: resolve => require(['views/export-history'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '生命银行扫码支付/生命银行扫码支付导出历史' }
},
{
  path: '/export-history/scan-payment-counselor',
  name: 'export-history-scan-payment-counselor',
  component: resolve => require(['views/export-history'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '生命银行扫码支付/生命银行扫码支付导出历史' }
},
{
  path: '/scan-payment-life-experience-hall',
  name: 'scan-payment-life-experience-hall',
  component: resolve => require(['views/scan-payment-counselor'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/export-history/scan-payment-life-experience-hall',
  name: 'export-history-scan-payment-life-experience-hall',
  component: resolve => require(['views/export-history'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '生命体验馆扫码支付/生命体验馆扫码支付导出历史' }
},
{
  path: '/scan-payment-storage',
  name: 'scan-payment-storage',
  component: resolve => require(['views/scan-payment-counselor'], resolve),
  meta: { auth: true, view: 'pc' }
},
{
  path: '/export-history/scan-payment-storage',
  name: 'export-history-scan-payment-storage',
  component: resolve => require(['views/export-history'], resolve),
  meta: { auth: true, view: 'pc', navInfo: '静态码收款业务/静态码收款业务导出历史' }
}
]
